import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import { useListCustomerCampaignPlatformQuery } from '../../redux/Api/CampaignManagment/cMCustomerCampaignPlatformApiSlice'
import EditCreateLOA from '../../components/campaigns/EditCreateLOA'
import { can } from '../../helpers/auth'
import NoPermission from '../pages/noPermission'
import { toast } from 'react-toastify'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'

const CampaignsLoa = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const {
    data: entries,
    isLoading,
    error,
    isFetching
  } = useListCustomerCampaignPlatformQuery({
    expand: ['campaign', 'customer', 'platform', 'last_updated_by'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ordering: 'id',
    search: search || undefined,
    ...filters
  })
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)
  const [holder, setHolder] = useState()

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'Campaign Name',
      dataIndex: 'campaign_name',
      key: 'campaign_name',
      filter: true,
      filterType: 'text',
      render: (text, record) =>
        record?.campaign_name || record?.campaign?.campaign_name || ''
    },
    {
      title: 'Customer',
      dataIndex: 'customer_name',
      key: 'customer_name',
      render: (text, record) =>
        record?.customer_name || record?.customer?.customer_name || ''
    },
    {
      title: 'Platform',
      dataIndex: 'platform_name',
      key: 'platform_name',
      render: (text, record) =>
        record?.platform_name || record?.platform?.platform_name || ''
    },

    {
      title: 'Campaign LOA',
      dataIndex: 'campaign_loa_dropbox_url',
      key: 'campaign_loa_dropbox_url',
      width: '20%'
    },
    {
      title: 'Last Updated By',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: (text, record) => {
        const { last_updated_by } = record
        return last_updated_by
          ? `${last_updated_by.first_name} ${last_updated_by.last_name}`
          : ''
      }
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          <button
            className='btn btn-outline-theme'
            onClick={() => handleEdit(record)}
          >
            Edit
          </button>
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  const context = useContext(AppSettings)
  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return function cleanUp () {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [])

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  if (!can('view_campaign')) {
    return <NoPermission />
  }

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />
      {edit ? (
        <EditCreateLOA
          state={'edit'}
          open={edit}
          setOpen={setEdit}
          campaign={holder}
        />
      ) : null}
      {create ? (
        <EditCreateLOA
          state={'create'}
          open={create}
          setOpen={setCreate}
          campaign={null}
        />
      ) : null}
      <div className='flex mb-4'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <button
          className='btn btn-outline-theme ml-auto mb-4'
          onClick={() => setCreate(true)}
        >
          Add New Customer LOA
        </button>
      </div>
      <br />
      {entries ? (
        <ReusableTable
          columns={columns}
          data={entries?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: entries?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      ) : null}
    </div>
  )
}

export default CampaignsLoa
